<template>
	<div class="app">
		
		<div class="container">
			<div class="row">
				<div class="col-2 d-none d-xl-block"></div>
				<div class="col-xl-8">

					<!-- <b-card class="mb-4">
						<h5>Опции для разработки</h5>
						<h6>
							Cтатус пользователя: {{ isVIP ? "VIP" : "Обычный" }}
						</h6>
						<p>
							VIP статус позволяет:
						</p>
						<ul>
							<li>сохранение без водяных знаков</li>
							<li>доступ к фильтрам</li>
						</ul>
						<div>
							<b-button
								variant="success"
								class="mt-2"
								@click="isVIP = !isVIP"
							>
								Переключить статус
							</b-button>
						</div>
					</b-card> -->

					<div class="app-tabs">
						<b-tabs justified>
							<!-- ================================= -->
							<b-tab active >
								<template #title>
									<b-icon
										icon="tools"
										aria-hidden="true"
									></b-icon>
									<strong>Настройки</strong>
								</template>

								<h6>Cоотношение сторон холста {{ currentRatio===aspectRatio_16_9 ? "16:9" : "4:3" }}</h6>
								<div>
									<b-button
										class="mt-2 mb-2"
										@click="toggleAspectRatio"
										variant="primary"
										size="sm"
										>
										<b-icon icon="aspect-ratio" aria-hidden="true"></b-icon>
										Изменить соотношение</b-button
									>
								</div>
								<hr>
								<div class="row">
									<div class="col-xl-6 col-sm-12">
										<Opacity
											:canvas="canvas"
											:value="opacity"
											:isSelected="isSelected"
										/>
									</div>
								</div>
								<hr>
								<div>
									<b-button
										pill
										variant="outline-primary"
										@click="canvas.clear()"
										size="sm"
										>Очистить холст</b-button
									>
								</div>
							</b-tab>
							<!-- ================================= -->
							<b-tab>
								<template #title>
									<b-icon
										icon="spellcheck"
										aria-hidden="true"
									></b-icon>
									<strong>Текст</strong>
								</template>
								<Fonts
									ref="fontsComponent"
									:canvas="canvas"
									:selectedType="selectedType"
									@enableEditingMode="
										enableEditingMode
									"
									:colorBrush="colorBrush"
									:valueShadowBlur="
										valueShadowBlur
									"
									:colorShadow="colorShadow"
									:offsetShadow="offsetShadow"
								/>
							</b-tab>
							<!-- ================================= -->
							<b-tab>
								<template #title>
									<b-icon
										icon="brightness-high-fill"
										aria-hidden="true"
									></b-icon>
									<strong>Тень</strong>
								</template>
								<Shadow
									:canvas="canvas"
									:blur="valueShadowBlur"
									:color="colorShadow"
									:offset="offsetShadow"
								/>
							</b-tab>
							<!-- ================================= -->
							<b-tab>
								<template #title>
									<b-icon
										icon="bezier"
										aria-hidden="true"
									></b-icon>
									<strong>Анимация</strong>
								</template>
								<Animations
									:canvas="canvas"
									:isSelected="isSelected"
								/>
							</b-tab>
							<!-- ================================= -->
							<!-- <b-tab :disabled="!isVIP"> -->
							<b-tab>
								<template #title>
									<b-icon
										icon="sliders"
										aria-hidden="true"
									></b-icon>
									<strong>Фильтры</strong>
								</template>
								<Filters
									:canvas="canvas"
									:isSelected="isSelected"
									:selectedType="selectedType"
								/>
							</b-tab>
							<!-- ================================= -->

						</b-tabs>
					</div>
				</div>
				<div class="col-2 d-none d-xl-block"></div>
			</div>
		</div>
		
		<div class="container">
			<div class="row">
				<div class="col-xl-2 app__side app__side-images col-sm-6">
					<Images
						:canvas="canvas"
						@enableEditingMode="enableEditingMode"
						ref="imagesComponent"
						:isTextureBrush="isTextureBrush"
						@setCurrentImage="setCurrentImage"
						:selectedType="selectedType"
					/>
				</div>
				<div class="col-xl-8 app__center">
					<!-- ================================= -->
					<div class="canvas-wrapper">
						<canvas id="canvas"></canvas>
					</div>
					<!-- ================================= -->
					<div class="row">
						<div class="col-md-6 col-sm-12 d-none d-md-block"></div>
						<div class="col-md-6 col-sm-12">
							<b-button-group class="mb-2 w-100 history-buttons">
								<!-- <b-button variant="outline-primary" @click="canvas.undo()" title="Отменить">
									<b-icon
										icon="arrow90deg-left"
										aria-hidden="true"
									></b-icon>
								</b-button> -->
								<!-- <b-button variant="outline-primary" @click="saveState" title="Сохранить состояние">
									Сохранить состояние
								</b-button>
								<b-button variant="outline-primary" @click="restoreState" title="Отменить">
									<b-icon
										icon="arrow90deg-left"
										aria-hidden="true"
									></b-icon>
								</b-button> -->
								<!-- <b-button variant="outline-primary" @click="canvas.redo()" titile="Вперед">
									<b-icon
										icon="arrow90deg-right"
										aria-hidden="true"
									></b-icon>
								</b-button> -->
								<b-button variant="outline-primary" @click="removeLayer">
									<b-icon
										icon="trash"
										aria-hidden="true"
									></b-icon>
									Удалить
								</b-button>
							</b-button-group>
						</div>
					</div>
					<Save :canvas="canvas" :isVIP="isVIP"  />

					

				</div>
				<div class="col-xl-2 app__side app__side-tools col-sm-6">
					<!-- ================================= -->
					<b-button
						block
						class="text-left"
						:variant="editingBtnStyle"
						@click="setMode('editing')"
					>
						<b-icon icon="arrows-move" aria-hidden="true"></b-icon>
						Двигать
					</b-button>
					<div v-if="mode === 'editing'">
						<LayerControls
							:canvas="canvas"
							:isSelected="isSelected"
							@enableEditingMode="enableEditingMode"
						/>
					</div>
					<!-- ================================= -->
					<b-button
						block
						class="text-left"
						:variant="drawingBtnStyle"
						@click="setMode('drawing')"
					>
						<b-icon icon="pencil-square" aria-hidden="true"></b-icon>
						Рисовать
					</b-button>

					<div v-if="mode === 'drawing'">
						<Brushes
							:canvas="canvas"
							:colorBrush="colorBrush"
							@close="setMode('editing')"
							:currentImage="currentImage"
							@changeTextureBrush="changeTextureBrush"
						/>
					</div>
					<!-- ================================= -->

					<b-button
						block
						class="text-left"
						@click="addText"
						variant="outline-primary"
					>
						<b-icon
							icon="textarea-t"
							aria-hidden="true"
						></b-icon>
						Текст
					</b-button>

					<div class="mb-2 mt-2 w-100">
						<b-button
							block
							class="text-left"
							variant="outline-primary"
							@click="
								$refs.fileInput.$el
									.querySelector('input[type=file]')
									.click()
							"
						>
							<b-icon
								icon="image"
								aria-hidden="true"
							></b-icon>
							Изображение
						</b-button>
						<b-form-file
							style="display:none"
							ref="fileInput"
							@input="inputImage"
							placeholder="Выбери файл или перетащи изображение"
							drop-placeholder="Отпускай :)"
							accept="image/*"
							browse-text="Изображение"
						></b-form-file>
					</div>

					<b-button
						block
						class="text-left"
						variant="outline-primary"
						@click="fillCanvas"
					>
						<b-icon icon="bucket" aria-hidden="true" rotate="-45"></b-icon>
						Залить
					</b-button>

					<div class="mt-2 mb-2 w-100">
						<label class="color-button" for="colorBrush">
							<div class="color-button__input">
								<b-form-input
									type="color"
									id="colorBrush"
									v-model="colorBrush"
									@input="updateColorBrush"
								></b-form-input>
							</div>
							<div class="color-button__text">Цвет</div>
						</label>
					</div>

					
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { fabric } from "fabric";
import "fabric-history";

import Brushes from "@/components/Brushes";
import LayerControls from "@/components/LayerControls";
import Shadow from "@/components/Shadow";
import Opacity from "@/components/Opacity";
import Animations from "@/components/Animations";
import Filters from "@/components/Filters";
import Images from "@/components/Images";
import Fonts from "@/components/Fonts";
import Save from "@/components/Save";

import test from "@/assets/popular/logo.png";
// [x] 	пагинация изображений
// [x] 	добавить Фильтры
// [x] 	анимация рандома очистить сеттаймаут
// [x] 	баг с гифкой
// [x]	шаг вперед назад
// [x]	ограничить функионал платный\бесплатный
// [x]	ватермарка вкл\выкл
// [x]	групировка мышкой
// [x]	соотношение сторон холста 16:9 или 4:3
// [x]	установка времени анимации пользователем

// [x]	превью фонтов
// [x]	откл фильтр на гифки
// [x]	разноцветный анимированный текст



export default {
	components: {
		Brushes,
		LayerControls,
		Shadow,
		Opacity,
		Animations,
		Filters,
		Images,
		Fonts,
		Save,
	},
	data() {
		return {
			state: null,
			undo: [],
			canvas: null,
			mode: "editing",
			colorBrush: "#00ff00",
			opacity: 1,
			valueShadowBlur: 0,
			colorShadow: "#000000",
			offsetShadow: {
				x: 0,
				y: 0,
			},
			isSelected: false,
			selectedType: "",
			selected: null,
			isVIP: false,
			width: 730,
			currentRatio: 0,
			aspectRatio_16_9: 1.777777777,
			aspectRatio_4_3: 1.333333333,
			isTextureBrush: false,
			currentImage:test,
		};
	},
	watch: {
	
	},
	created(){
		// const waterMarkBlock = document.querySelector('.water-mark');
		// let dataLogin = waterMarkBlock.dataset.waterMark;
		// console.log('dataLogin:');
		// console.log(dataLogin);
		// if(dataLogin === 'false'){
		// 	this.isVIP = false;
		// } else if(dataLogin === 'true')
		// 	{
		// 		this.isVIP = true;
		// 	}
		
		// console.log('isVIP: ' + this.isVIP);
		// console.log('!!!!!!!!!!!!!!!!!!!!!!!!');

		
		this.currentRatio = this.aspectRatio_16_9
	},
	computed: {
		height(){
			return this.width / this.currentRatio
		},
		editingBtnStyle() {
			return this.mode === "editing" ? "primary" : "outline-primary";
		},
		drawingBtnStyle() {
			return this.mode === "drawing" ? "primary" : "outline-primary";
		},
	},
	methods: {
		// saveState(){
		// 	if (this.state) {
        //     this.undo.push(this.state);
        // }
		// 	this.state = JSON.stringify(this.canvas);
		// 	// console.log(this.state);
		// },
		// restoreState(){
		// 	// try {
		// 	// 	if(this.state){
		// 	// 		this.canvas.loadFromJSON(this.state, function() {
		// 	// 			this.canvas.renderAll();
		// 	// 			});
		// 	// 	}
				
		// 	// } catch (error) {
		// 	// 	console.log("canvas.loadFromJSON error:");
		// 	// 	console.log(error);
		// 	// }
		// 	if(this.state){
		// 			this.canvas.loadFromJSON(this.state, ()=> {
		// 				this.canvas.renderAll();
		// 				});
		// 		}
		// },
		// canvasUndo(){
		// 	this.canvas.undo();
		// 	this.canvas.requestRenderAll();
		// },
		removeLayer() {
			if (!this.canvas.getActiveObject()) {
				return;
			}
			if (this.canvas.getActiveObject().type !== 'activeSelection') {
				this.canvas.remove(this.canvas.getActiveObject());
				this.canvas.requestRenderAll();
				return;
			}else{
				this.canvas.getActiveObject().toGroup();
				this.canvas.requestRenderAll();
				this.canvas.remove(this.canvas.getActiveObject());
				this.canvas.requestRenderAll();
			}
		},
		changeTextureBrush(value){
			this.isTextureBrush = value
			console.log("this.isTextureBrush = ",this.isTextureBrush)
		},
		setCurrentImage(image){
			this.currentImage = image
			console.log("setCurrentImage = ", image )
		},
		toggleAspectRatio(){
			const setSize = () =>{
				this.canvas.setDimensions({
					width: this.width,
					height: this.height
				})
			}
			if (this.currentRatio === this.aspectRatio_16_9){
				this.currentRatio = this.aspectRatio_4_3
				console.log("aspectRatio_4_3")
				setSize()
			}else{
				this.currentRatio = this.aspectRatio_16_9
				setSize()
				console.log("aspectRatio_16_9")
			}
			
		},
		setMode(mode) {
			this.changeTextureBrush(false)
			switch (mode) {
				case "drawing":
					this.canvas.isDrawingMode = true;
					break;
				case "editing":
					this.canvas.isDrawingMode = false;
					break;

				default:
					break;
			}
			this.mode = mode;
		},
		fillCanvas() {
			this.canvas.backgroundColor = this.colorBrush;
			this.canvas.requestRenderAll();
		},
		inputImage(file) {
			this.$refs.imagesComponent.drawReceivedImage(file);
			
			this.changeTextureBrush(false)
		},
		addText() {
			this.enableEditingMode();
			setTimeout(() => {
				this.$refs.fontsComponent.addText();
			}, 0);
		},
		updateColorBrush() {
			let brush = this.canvas.freeDrawingBrush;
			brush.color = this.colorBrush;
			if (brush.getPatternSrc) {
				brush.source = brush.getPatternSrc.call(brush);
			}
			if(this.selectedType === "text"){
				const target = this.canvas.getActiveObject();
				target.set('fill', this.colorBrush);
				// target.set('stroke', "#000000");
				// target.set('strokeWidth', "5");

				// this.canvas.renderAll();
				// this.canvas.requestRenderAll();
			}
		},
		enableEditingMode() {
			this.changeTextureBrush(false)
			this.canvas.isDrawingMode = false;
			this.mode = "editing";
		},
		onSelectedLayer() {
			const target = this.canvas.getActiveObject();
			this.isSelected = true;
			this.selectedType = false;
			this.selected = target;
			this.opacity = target.opacity;
			if (target.shadow) {
				this.valueShadowBlur = target.shadow.blur;
				this.colorShadow = target.shadow.color;
				this.offsetShadow.x = target.shadow.offsetX;
				this.offsetShadow.y = target.shadow.offsetY;
			}

			console.log("__proto__ = ", target.__proto__.type);
			switch (target.__proto__.type) {
				case "textbox":
					this.selectedType = "text";
					break;
				case "image":
					if(target.mode === "image"){
						this.selectedType = "gif"
					}else{
						this.selectedType = "image";
					}
					break;
				case "path":
					this.selectedType = "path";
					break;
				default:
					break;
			}

			// if (target.filters) {
			// 	this.currentFilter = Object.keys(target.filters[0])[0];
			// }
			console.log("this.selectedType = ", this.selectedType);
			console.log("this.currentFilter = ", this.currentFilter);
			console.log("target = ", target);
			console.log("canvas = ", this.canvas);
			// console.log(target.canvas["requestRenderAllBound"]);
		},
		init() {
			console.log("fabric = ", fabric);

			this.canvas = new fabric.Canvas("canvas", {
				preserveObjectStacking: true,
				backgroundColor: "#ffffff",
			});
			this.canvas.setDimensions({
				width: this.width,
				height: this.height
			})
			console.log("this.canvas = ", this.canvas);

			fabric.Object.prototype.transparentCorners = false;
			this.setMode("drawing");
			this.canvas.freeDrawingBrush.width = 25
			this.updateColorBrush();
			
			this.canvas.on("selection:created", () => {
				console.log("selection:created");
				this.onSelectedLayer();
			});

			this.canvas.on("selection:updated", () => {
				console.log("selection:updated");
				this.onSelectedLayer();
			});
			this.canvas.on("selection:cleared", () => {
				console.log("selection:cleared");
				this.selectedType = false;
				this.opacity = 1;
				this.isSelected = false;
				this.valueShadowBlur = 0;
				this.colorShadow = "#000000";
				this.offsetShadow.x = 0;
				this.offsetShadow.y = 0;
				this.currentFilter = "";
				
			});
			this.canvas.on("object:modified", () => {
				console.log("object:modified");
			});

		},
	},
	mounted() {
		this.init();
	},
};
</script>
